import type { ReactNode } from 'react';

import { Card } from '@nucleus-commerce/ui/components/card';
import { Skeleton } from '@nucleus-commerce/ui/components/skeleton';
import { cn } from '@nucleus-commerce/ui/lib/utils';

export interface StatCardProps {
  label: string;
  /** Undefined renders a skeleton in place of the number. */
  value: number | string | undefined;
  hint?: ReactNode;
  /** Gold number for the one figure the screen is about. */
  emphasis?: boolean;
  className?: string;
}

/** KPI tile: small label, big tabular number, one line of context. */
export function StatCard({ label, value, hint, emphasis = false, className }: StatCardProps) {
  return (
    <Card role="group" aria-label={label} className={cn('gap-2 px-5 py-4', className)}>
      <span className="text-muted-foreground text-[0.8125rem]">{label}</span>
      {value === undefined ? (
        <Skeleton className="h-8 w-16" />
      ) : (
        <span
          className={cn(
            'text-[1.75rem] leading-none font-semibold tracking-tight tabular-nums',
            emphasis && 'text-primary',
          )}
        >
          {value}
        </span>
      )}
      {hint !== undefined ? (
        <span className="text-muted-foreground min-h-4 text-xs">{hint}</span>
      ) : null}
    </Card>
  );
}
